import { render, staticRenderFns } from "./SettingsTravelServiceAdditionalSettingsView.vue?vue&type=template&id=c8ec7e88&scoped=true&"
import script from "./SettingsTravelServiceAdditionalSettingsView.vue?vue&type=script&lang=js&"
export * from "./SettingsTravelServiceAdditionalSettingsView.vue?vue&type=script&lang=js&"
import style0 from "./SettingsTravelServiceAdditionalSettingsView.vue?vue&type=style&index=0&id=c8ec7e88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ec7e88",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCheckbox,VIcon,VRadio,VRadioGroup,VRow,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8ec7e88')) {
      api.createRecord('c8ec7e88', component.options)
    } else {
      api.reload('c8ec7e88', component.options)
    }
    module.hot.accept("./SettingsTravelServiceAdditionalSettingsView.vue?vue&type=template&id=c8ec7e88&scoped=true&", function () {
      api.rerender('c8ec7e88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/travel-service/SettingsTravelServiceAdditionalSettingsView.vue"
export default component.exports